import type { AllRouteEndpoints } from "../routeTypes";

export const alloysGeminiAgenticAppGroupIdOauthConnect = "/alloys/gemini/agentic/:app_group_id/oauth/connect";

export const alloysGeminiAgenticAppGroupIdOauthProjects = "/alloys/gemini/agentic/:app_group_id/oauth/projects";

export const alloysGeminiAgenticAppGroupIdOauthVerifyProject =
  "/alloys/gemini/agentic/:app_group_id/oauth/verify_project";

export const alloysGeminiAgenticAppGroupIdOauthSelectProject =
  "/alloys/gemini/agentic/:app_group_id/oauth/select_project";

export const alloysGeminiAgenticAppGroupIdOauthDisconnect = "/alloys/gemini/agentic/:app_group_id/oauth/disconnect";

export const postAlloysGeminiAgenticOauthConnectCacheKeys: AllRouteEndpoints[] = [
  "/alloys/:provider/agentic/:app_group_id",
];

export const getAlloysGeminiAgenticOauthProjectsCacheKey = alloysGeminiAgenticAppGroupIdOauthProjects;

export const postAlloysGeminiAgenticOauthSelectProjectCacheKeys: AllRouteEndpoints[] = [
  "/alloys/:provider/agentic/:app_group_id",
  alloysGeminiAgenticAppGroupIdOauthProjects,
];

export const deleteAlloysGeminiAgenticOauthDisconnectCacheKeys: AllRouteEndpoints[] = [
  "/alloys/:provider/agentic/:app_group_id",
];
